import React from 'react';
import { MapPinIcon, GitMergeIcon, ColumnsIcon, RepeatIcon } from 'lucide-react';
import { CheckoutButton } from '../CheckoutButton';
const steps = [{
  n: '01',
  title: 'Locate',
  icon: MapPinIcon,
  text: 'See exactly where you are within the bigger Prosthodontics picture.'
}, {
  n: '02',
  title: 'Connect',
  icon: GitMergeIcon,
  text: 'Understand how one concept relates to the next.'
}, {
  n: '03',
  title: 'Compare',
  icon: ColumnsIcon,
  text: 'Quickly distinguish concepts, materials, techniques, and classifications that are easy to mix up.'
}, {
  n: '04',
  title: 'Review',
  icon: RepeatIcon,
  text: 'Use visual maps, checklists, and active-recall questions to test what you actually remember.'
}];
export function MethodSection() {
  return <section className="bg-white px-4 py-14 sm:py-20" data-id="element-207" data-mp="11ppmcycp82zo">
      <div className="mx-auto w-full max-w-3xl" data-id="element-208" data-mp="16niuhwxkb72l">
        <div className="text-center" data-id="element-209" data-mp="16m7l9hlcl743">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-aqua-500" data-id="element-210" data-mp="16l4vjczrhapr">
            🧠 The Prostho 360™ method
          </p>
          <h2 className="mt-3 font-display text-[28px] font-bold leading-[1.12] tracking-tight text-navy-900 sm:text-4xl" data-id="element-211" data-mp="i5282dpchrio">
            You don't need another PDF. <span className="italic text-aqua-500" data-id="element-212" data-mp="rvwylu9mjd9x">You need a map.</span>
          </h2>
          <p className="mt-4 text-[15px] text-navy-800/70 sm:text-lg" data-id="element-213" data-mp="rxzvmy9726o5">
            PROSTHO 360™ uses a simple 4-step review system.
          </p>
        </div>

        <ol className="mt-9 space-y-3" data-id="element-214" data-mp="3vdxahkiaw2st">
          {steps.map(({
          n,
          title,
          icon: Icon,
          text
        }) => <li key={n} className="flex gap-4 rounded-2xl bg-sand-50 p-4 ring-1 ring-navy-800/8 sm:p-5" data-id="element-215" data-mp="d7secluxatp1">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-navy-900" data-id="element-216" data-mp="1om5wrb6wqgxo">
                <Icon className="h-5 w-5 text-aqua-400" aria-hidden="true" data-id="element-217" data-mp="1kkughw9xb825" />
              </div>
              <div className="min-w-0" data-id="element-218" data-mp="h9nc40nrqiwh">
                <h3 className="text-[15px] font-extrabold uppercase tracking-wide text-navy-900" data-id="element-219" data-mp="h8lrp5kv4k23">
                  <span className="text-aqua-500" data-id="element-220" data-mp="m7oraai2py2o">{n}</span> — {title}
                </h3>
                <p className="mt-1 text-[14.5px] leading-relaxed text-navy-800/70" data-id="element-221" data-mp="r8w2yknc7hem">{text}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-8 rounded-2xl border border-navy-800/10 bg-white p-5 shadow-card sm:p-6" data-id="element-222" data-mp="v73ijc62eco8">
          <p className="text-[13px] font-semibold uppercase tracking-wide text-navy-800/45" data-id="element-223" data-mp="3umqfbne3trxo">Instead of:</p>
          <p className="mt-1 text-[16px] font-medium italic text-navy-800/60" data-id="element-224" data-mp="7jvh55brbnrh">
            “I need to study Prosthodontics.”
          </p>
          <p className="mt-4 text-[13px] font-semibold uppercase tracking-wide text-aqua-500" data-id="element-225" data-mp="cbls9diiqfjy">You can say:</p>
          <p className="mt-1 font-display text-[19px] font-bold leading-snug text-navy-900 sm:text-2xl" data-id="element-226" data-mp="3bxae0xulhvg7">
            “I know exactly what I need to review for the next 15 minutes.”
          </p>
        </div>

        <div className="mt-8" data-id="element-227" data-mp="38fme0fzezswl">
          <CheckoutButton label="Get access to Prostho 360™" sub="$27 one-time · Lifetime access" data-id="element-228" data-mp="38dryxiatqv0f" />
        </div>
      </div>
    </section>;
}